import { sanitize } from "dompurify";

type SanitizedPageContentProps = {
    html: string | undefined | null;
    classes?: string;
    onClick?: () => void;
};

export function SanitizedPageContent({ html, classes, onClick }: SanitizedPageContentProps) {
    if (!html) {
        return null;
    }

    const sanitizedContent = sanitize(html, {
        ALLOWED_TAGS: [
            'b',
            'i',
            'em',
            'strong',
            'a',
            'ol',
            'ul',
            'li',
            'img',
            'span',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'blockquote',
            'pre',
            'p',
            'sup',
            'sub',
            's',
            'u',
            'iframe',
            'div',
            'br',
            'table',
            'td',
            'tr'
        ],
        ALLOWED_ATTR: [
            'href',
            'target',
            'src',
            'allowfullscreen',
            'class',
            'frameborder',
            'width',
            'height',
            'sandbox',
            'title',
            'class',
            'style'
        ],
    });


    return (
        <div
            className={classes}
            dangerouslySetInnerHTML={{ __html: sanitizedContent }}
            onClick={onClick}
        />
    );
}